import { render, staticRenderFns } from "./ChatDialogue.vue?vue&type=template&id=34e2d262&scoped=true"
import script from "./ChatDialogue.vue?vue&type=script&lang=js"
export * from "./ChatDialogue.vue?vue&type=script&lang=js"
import style0 from "./ChatDialogue.vue?vue&type=style&index=0&id=34e2d262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e2d262",
  null
  
)

export default component.exports